module.exports = "<div id=\"category-filter\" class=\"aside__filters v10\">\r\n  <div class=\"widget__products widget-aside v10\">\r\n    <h6 class=\"widget-aside__title\">Líneas de Productos</h6>\r\n    <div class=\"widget-aside__wrapper widget__accordion\">\r\n      <categories-accordion items=\"$ctrl.shCtrl.globalCategoriesMenu[0].hijas\"></categories-accordion>\r\n    </div>\r\n  </div>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/catalog/categories-filter/categories-slider-filter/templates/categories-slider-filter-t10.view.html
 ** module id = 426
 ** module chunks = 0
 **/